export const ROUTES = {
  FEED: '/feed',
  ADV_SEARCH: '/search',
  LOGIN: '/login',
  PROFILE: '/profile',
  NETWORK: '/network',
  AI_SEARCH: '/ai-search',
};
